import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=44724220&scoped=true"
import script from "./comment.vue?vue&type=script&lang=js"
export * from "./comment.vue?vue&type=script&lang=js"
import style0 from "../../../static/css/comment.css?vue&type=style&index=0&id=44724220&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44724220",
  null
  
)

export default component.exports